import React from 'react'
import formImg from '../images/header-bg.png'
import { useLocation, useNavigate } from 'react-router'

const Status = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const params = new URLSearchParams(window.location.search)
    const status = location.state?.status || params.get('status')
    console.log(params.get('status'))

    React.useEffect(() => {
        if (status === null ) {
            navigate('/')
        }
    }, [])

    const Success = () => {
        return (
            <div className='flex flex-col bg-white shadow-box2 py-20 px-10 my-20 text-center w-11/12 rounded-xl font-poppins items-center justify-center gap-16'>
                <p className='text-[#1D58E2] font-light text-6xl leading-snug'>{location.state?.account_type === 'individual' ? <>Thank you for choosing our<br />Individual Plan!</> : location.state?.account_type === 'enterprise' ? 'Thank you for choosing our Enterprise Plan!' : 'Thank you for choosing our service!'}</p>
                <p className='text-xl'>{location.state?.account_type === 'individual' ? "We're excited to have you on board. Your subscription is now active." : location.state?.account_type === 'enterprise' ? "We're pleased to confirm that our sales team will connect with you soon to provide their best offers, tailored to your requirements." : "We're excited to have you on board. Your subscription is now active, and you can expect your invoice shortly via email"}</p>
                <p className=''>If you have any questions or need assistance, feel free to reach out. We're here to help!</p>
            </div>
        )
    }

    const Failure = () => {
        return (
            <div className='flex flex-col bg-white shadow-box2 py-20 px-10 my-20 text-center w-11/12 rounded-xl font-poppins items-center justify-center gap-16'>
                <p className='text-[#FF0019] font-light text-6xl leading-none'>{location.state?.account_type !== 'small-business' ? <>Sorry! We could not process <br /> your request</> : <>Sorry! Your payment was <br /> unsuccessful.</>}</p>
                <p className='text-xl'>{location.state?.account_type !== 'small-business' ? <>This may have occurred due to various reasons, such as a server outage <br /> or ongoing maintenance. Please try again later.</> : 'This may have occurred due to a variety of reasons, such as insufficient funds, incorrect card details, or a connection issue with your bank.'}</p>
                {location.state?.account_type === 'small-business' && <p className='text-lg'>Please review your payment details and try again, or use an alternate payment method.</p>}
                <button className='py-3 bg-[#1D58E2] w-2/12 text-white mx-auto font-inter font-medium text-lg hover:bg-[#D2232A]' onClick={() => navigate('/')}>Try Again</button>
                <p className='italic text-sm'>If you continue to experience issues, feel free to contact our support team at <span className='text-[#1D58E2] cursor-pointer'>support@smarteye.com</span>, and we'll be happy to assist you further</p>
            </div>
        )
    }

    return (
        <div className='flex items-center h-screen bg-[#EFF4FF] justify-center bg-center bg-cover bg-no-repeat' style={{ backgroundImage: `url(${formImg})` }}>
            {status !== 'failed' ?
                <Success />
                :
                <Failure />
            }
        </div>
    )
}

export default Status

